import { render } from "./PanelGroup.vue?vue&type=template&id=d0df71c2&scoped=true"
import script from "./PanelGroup.vue?vue&type=script&lang=js"
export * from "./PanelGroup.vue?vue&type=script&lang=js"

import "./PanelGroup.vue?vue&type=style&index=0&id=d0df71c2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d0df71c2"

export default script